/* global TweenMax TimelineMax Sine Circ Quad Quint Expo:true  */
import $ from '@vaersaagod/tools/Dom';

export default el => {
    const $el = $(el);
    const $input = $el.find('[data-filter]');
    const $items = $el.find('[data-item]');
    let currentInputVal = '';

    const parseItem = item => {
        const itemText = $(item).find('[data-text]').text().toLowerCase();
        return itemText.indexOf(currentInputVal) === -1;
    };

    const filterItems = str => {
        currentInputVal = str;
        const hideItems = $items.filter(parseItem);
        TweenMax.set($items.nodes, { clearProps: 'all' });
        TweenMax.set(hideItems.nodes, { display: 'none' });
    };

    const onInputChange = () => {
        const newVal = $input.val().trim().toLowerCase();
        if (newVal !== currentInputVal) {
            filterItems(newVal);
        }
    };

    const init = () => {
        $input.on('change paste keyup', onInputChange);
    };

    const destroy = () => {
        $input.off('change paste keyup', onInputChange);
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/ProductList.js